import { Injectable } from '@angular/core';
import moment from 'moment';
import { SESSION_STORAGE_KEY } from '@core/configs/local-storage-key.config';
import { UserSession } from '@core/models/interfaces';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {

    constructor() { }

    // Lưu dữ liệu vào sessionStorage
    setSessionData(key: string, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    // Lấy dữ liệu từ sessionStorage
    getSessionData<T = any>(key: string): T | null {
        const data = sessionStorage.getItem(key);
        return data ? JSON.parse(data) as T : null;
    }

    // Xóa dữ liệu trong sessionStorage
    removeSessionData(key: string): void {
        sessionStorage.removeItem(key);
    }

    // Xóa toàn bộ sessionStorage
    clearSession(): void {
        sessionStorage.clear();
    }

    setUserSession(value: UserSession): void {
        this.setSessionData(SESSION_STORAGE_KEY.loginSession, value);
    }

    // save current Japan time as last login time
    setLoginDateTime(): void {
        this.setSessionData(SESSION_STORAGE_KEY.loginDateTime, moment().utcOffset(9).format('YYYY-MM-DD HH:mm'));
    }

    getUserSession(): UserSession | null {
        return this.getSessionData<UserSession>(SESSION_STORAGE_KEY.loginSession);
    }

    getAccessToken(): string {
        const userSession = this.getUserSession();
        return userSession ? userSession.accessToken : "";
    }

    getRefreshToken(): string {
        const userSession = this.getUserSession();
        return userSession ? userSession.refreshToken : "";
    }

}
